import { create } from "zustand";
import { persist } from "zustand/middleware";
import { queryClient } from "@/adapters/tanstack-query/query-client.ts";

export type AuthProvider = "password" | "google";

export interface AuthUser {
	name: string;
	email: string;
}

export interface AuthSession {
	token: string;
	user: AuthUser;
	provider: AuthProvider;
}

interface AuthState {
	session: AuthSession | null;
	signIn: (session: AuthSession) => void;
	signOut: () => void;
}

export const useAuth = create<AuthState>()(
	persist(
		(set) => ({
			session: null,
			signIn: (session) => set({ session }),
			signOut: () => {
				queryClient.clear();
				set({ session: null });
			},
		}),
		{ name: "otd-auth" },
	),
);
